import { AuthProviderProps } from "react-oidc-context";
import {
  User,
  UserManagerSettings,
  WebStorageStateStore,
} from "oidc-client-ts";
import { getConfig } from "./services/configService";
import { getUser, postUser } from "./api/userApi.ts";
import { initUserManager } from "./auth/userManager.ts";

export interface KeycloakProfile {
  realm_access?: {
    roles: string[];
  };
}

const onSigninCallback = (user: void | User): void => {
  if (user && !user.expired) {
    getUser(user.profile.sub, user).catch((error) => {
      if (error.status && error.status === 404) {
        postUser(
          {
            firstName: user.profile.given_name || "",
            lastName: user.profile.family_name || "",
            email: user.profile.email || "",
            setupWizardDone: false,
          },
          user,
        ).catch((reason) => console.error(reason));
      } else {
        console.error(error);
      }
    });
  }
  window.history.replaceState({}, document.title, window.location.pathname);
};

export async function getOidcConfig(): Promise<AuthProviderProps> {
  const config = await getConfig();

  const settings: UserManagerSettings = {
    authority: config.keycloak.baseUrl + "/realms/" + config.keycloak.realm,
    client_id: config.keycloak.client,
    redirect_uri: window.location.origin + "/login-callback",
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    post_logout_redirect_uri: config.baseUrl,
  };

  const userManager = initUserManager(settings);

  return {
    userManager,
    onSigninCallback: onSigninCallback,
  };
}
